/*******************************************************************************
 * Project：
 * Summary:
 *　　 InpSiteFindingComponent
 * Remarks:
 *     inspec modal component
 * History：
 *      QuangTN            2021/07/26    Create
 ******************************************************************************/
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Utility } from '../../utility/utility';
@Component({
  selector: 'app-inp-site-finding',
  templateUrl: './inp-site-finding.component.html',
  styleUrls: ['./inp-site-finding.component.scss']
})
export class InpSiteFindingComponent implements OnInit, OnChanges {
  @Input() inpType5: any;
  @Input() idInput: any;
  @Input() disabledInput: any;
  @Input() maxlengthInput: any;
  @Output() outType5 = new EventEmitter();
  @Output() focusInput = new EventEmitter();
  inputObj: any = {};
  showDropDown = false;
  isOpenModal = false;
  selectedValue: string;
  PopInpAssistant: NgbModalRef;
  @ViewChild('PopInpAssistant', { static: true }) PopInpAssistantRef: ElementRef;
  lstItem: any[] = [
    { code: '1', value: '異常なし' },
    { code: '2', value: '部位所見入力' },
  ];
  constructor(
    private popupService: NgbModal, private util: Utility) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.util.isNullOrEmpty(changes) && !this.util.isNullOrEmpty(changes.inpType5)) {
      this.inputObj = changes.inpType5.currentValue;
    }
  }

  ngOnInit(): void {
    for (const i of this.lstItem) {
      i.active = false;
    }
  }
  selected(it: any) {
    this.lstItem.map(m => m.active = false);
    it.active = true;
    if (it.value === '部位所見入力') {
      this.isOpenModal = true;
      this.openModalFAC0401();
      this.lstItem.map(m => m.active = false);
      this.showDropDown = false;
    } else {
      this.isOpenModal = false;
      this.selectedValue = it.value;
      this.outSelectValue();
    }
  }
  outSelectValue() {
    this.showDropDown = false;
    if (!this.isOpenModal) {
      this.inputObj.HTItemResult = this.selectedValue;
      this.outType5.emit(this.inputObj);
    }
  }
  openModalFAC0401() {
    this.PopInpAssistant = this.popupService.open(this.PopInpAssistantRef, {
      backdrop: 'static', keyboard: false, size: ' w1240', centered: true
    });
  }
  ClosePop0401(resObj: any) {
    this.PopInpAssistant.close();
    this.selectedValue = resObj.value;
    this.inputObj.HTItemResult = resObj.value;
    this.inputObj.Parts = resObj.lstPart;
    this.inputObj.Opinions = resObj.lstOpinion;
    this.outType5.emit(this.inputObj);
  }
  focusIn(value: any) {
    this.isOpenModal = false;
    this.focusInput.emit(true);
  }
  focusOunt() {
    this.focusInput.emit(false);
  }
}
